import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { PseudoStates, PageTitle } from '@cordata/buffet';

import {
  adminInstance as axios,
} from '~/utils';

import ClinicalTrialsForm from '~/components/ClinicalTrial/Form';

const ClinicalTrialsDetails = () => {
  const params = useParams();
  const [data, setData] = useState({});
  const [error, setError] = useState();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    axios
      .get(`/clinical-trial/${params.clinical_trial_id}`)
      .then(r => r.data.data)
      .then(r => setData(r))
      .catch(e => setError(e))
      .then(() => setIsLoading(false));
  }, []);

  return (
    <>

      {!isLoading && !error ? (
        <>
          <PageTitle>{data.attributes.clinicalTrialName}</PageTitle>

          <ClinicalTrialsForm data={data} params={params} />
        </>
      ) : (
        <PseudoStates isLoading={isLoading} data={data} error={error} />
      )}
    </>
  );
};

export default ClinicalTrialsDetails;
